import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { fetchOwnerItems } from '../actions';
import { getAllWithoutNull } from '../selectors';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';

const marketingLeadsProvider = compose(
  withActiveUserIdAndType({ useShopForBarber: true }),
  connect(
    state => ({
      marketingLeads: getAllWithoutNull(state),
    }),
    { fetchOwnerItems }
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchOwnerItems(this.props.activeId, this.props.activeType);
    },
  })
);

export default marketingLeadsProvider;
